import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { AdminPageTitle, AdminPageTemplate, AdminLicenseConfig } from 'components';

class CtAdminExamTemplate extends PureComponent {

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate>
        <AdminPageTitle small title={'Setting'} />
        <AdminLicenseConfig />
      </AdminPageTemplate>
    );
  }
}

CtAdminExamTemplate.propTypes = {};
CtAdminExamTemplate.defaultProps = {};

export default injectIntl(CtAdminExamTemplate);



// WEBPACK FOOTER //
// ./src/script/containers/admin/license/CtAdminLicenseConfig.js